const tasks = {
  id: "tasks",
  label: "Tasks",
  endpoint: "tasks",
  columnConfig: [
    {
      field: "name",
      headerName: "Task",
      width: 250,
      description: "Task",
      editable: true,
    },
    {
      field: "wma_id",
      headerName: "WMA ID",
      width: 250,
      description: "WMA ID",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  requiredCreateFields: ["wma_id", "name"],
  chipConfig: {},
  tagConfig: {},
};

export default tasks;
